import React, { useState } from 'react';
import { useAppState } from '../AppStateContext.tsx';
import { Promotion } from './Promotion.jsx';
import { LinkSectionList } from './LinksSectionList.jsx';

export const setTabIndex = (isActive) => {
  return !isActive ? -1 : undefined;
};

export const SiteHeaderNavigation = ({ navItem, id, isActive, index, isMobile }) => {
  const { setIsMenuVisible, setSelectedLink, menuLevel, selectedProductSection, setMenuLevel, setSelectedMenu } =
    useAppState();

  const siteHeaderConfiguration = _THULEDATA._siteHeader;
  /* const translation = _THULEDATA._translations; */

  return (
    <div
      className={`menuLevel-${menuLevel}${isMobile ? '' : ' navigationOverlay'}${isActive ? ' active' : ''}`}
      id={id}
    >
      <div className="navigation sub-navigation">
        <div className={`sitePadding navigationItem navigationActionBar ${menuLevel > 2 ? 'd-none' : ''}`}>
          {isMobile ? (
            <button
              className="btn d-lg-block"
              tabIndex={setTabIndex(isActive)}
              onClick={() => {
                setMenuLevel(1);
                setSelectedMenu(null);
              }}
            >
              <span className="sr-only">Close menu </span>
              <i className="le-icon-chevron me-4"></i>
              <span className="navigationHeading">{navItem.Title}</span>
            </button>
          ) : (
            <button
              className="btn d-none d-lg-block"
              tabIndex="-1"
              aria-hidden="true"
              onClick={(e) => {
                setIsMenuVisible(false);
                setMenuLevel(1);
                setSelectedMenu(null);
              }}
            >
              <i className="le-icon-x"></i>
              {/* Translation close menu or close + menu*/}
              <span className="sr-only">Close menu {navItem.Title}</span>
            </button>
          )}
        </div>
        {navItem.ProductSections?.length && (
          <ul className="menuSecondaryLevel">
            {navItem.ProductSections.map((productSection, i) => (
              <SecondLevelMenuItem
                productSection={productSection}
                key={i}
                index={i}
                isActive={isActive}
                controllid={`${id}-category-${i}`}
                navMenuTitle={navItem.Title}
                isMobile={isMobile}
              />
            ))}
          </ul>
        )}
        <LinkSectionList navItem={navItem} index={index} isActive={isActive} />
        <Promotion promotion={navItem.PromotionField} isActive={isActive && menuLevel == 2} />
        {navItem.ProductSections && navItem.ProductSections.length ? (
          navItem.ProductSections.map(
            (productSection, i) =>
              productSection?.PromotionField && (
                <Promotion
                  promotion={productSection.PromotionField}
                  isActive={selectedProductSection == productSection}
                  key={i}
                />
              )
          )
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

const SecondLevelMenuItem = ({ productSection, index, controllid, isActive, navMenuTitle, isMobile }) => {
  const { setSelectedLink, setMenuLevel, setSelectedProductSection, selectedProductSection, menuLevel } = useAppState();
  return (
    <li className={menuLevel != 2 && selectedProductSection !== productSection ? 'd-none' : ''}>
      {productSection.Url ? (
        <a
          onClick={() => setSelectedLink(productSection.EnglishTitle)}
          href={productSection.Url}
          className={`navigationItem navigationHeading`}
        >
          {productSection.Name}
        </a>
      ) : (
        <>
          <button
            onClick={() => {
              setSelectedProductSection(productSection);
              setMenuLevel(3);
            }}
            className={`btn navigationItem ${menuLevel != 2 ? 'd-none' : ''}`}
            aria-controls={productSection.Categories && productSection.Categories.length ? controllid : undefined}
            aria-expanded={selectedProductSection == productSection}
            tabIndex={setTabIndex(isActive)}
            aria-label={`${selectedProductSection == productSection ? 'Close' : 'Open'} menu ${productSection.Name}`}
          >
            <span className="navigationHeading">{productSection.Name}</span>
            <i className="le-icon-chevron rot-180" aria-hidden="true"></i>
          </button>
          {productSection.Categories && productSection.Categories.length ? (
            <NavigationTertiaryLevel
              categories={productSection.Categories}
              expanded={selectedProductSection == productSection}
              productName={productSection.Name}
              navMenuTitle={navMenuTitle}
              id={controllid}
              isMobile={isMobile}
            />
          ) : (
            <></>
          )}
        </>
      )}
    </li>
  );
};

const NavigationTertiaryLevel = ({ categories, expanded, productName, navMenuTitle, id, isMobile }) => {
  const {
    setIsMenuVisible,
    setSelectedLink,
    setMenuLevel,
    setSelectedProductSection,
    setSelectedCategory,
    selectedCategory,
    menuLevel,
  } = useAppState();
  const siteHeaderConfiguration = _THULEDATA._siteHeader;
  return (
    <ul className={`menuTertiaryLevel ${expanded ? '' : 'siteHeader_hidden'}`} aria-expanded={expanded} id={id}>
      <li className={isMobile && menuLevel == 4 ? 'd-none' : ''}>
        <div className="navigationItem navigationActionBar menuLevel-3">
          <button
            tabIndex={isMobile && menuLevel == 4 ? -1 : setTabIndex(expanded)}
            className="btn false"
            aria-label={`back to ${navMenuTitle} menu`}
            onClick={(e) => {
              setMenuLevel(2);
              setSelectedCategory(null);
              setSelectedProductSection(null);
              if (e.currentTarget) {
                e.currentTarget.blur();
              } else {
                e.target.parentNode.blur();
              }
            }}
          >
            <i className="le-icon-chevron me-4"></i>

            <span className="navigationHeading">{productName}</span>
          </button>
          {!isMobile && (
            <button
              tabIndex="-1"
              aria-hidden="true"
              onClick={(e) => {
                setIsMenuVisible(false);
                setSelectedCategory(null);
                setSelectedProductSection(null);
                setMenuLevel(2);
                if (e.currentTarget) {
                  e.currentTarget.blur();
                } else {
                  e.target.parentNode.blur();
                }
              }}
              className="btn d-none d-lg-block"
            >
              <i className="le-icon-x"></i>
              <span className="sr-only">Close {navMenuTitle} menu</span>
            </button>
          )}
        </div>
      </li>
      {categories.map((category, index) => (
        <li key={index} className={isMobile && menuLevel == 4 ? (selectedCategory != category ? 'd-none' : '') : ''}>
          {siteHeaderConfiguration.HideSubcategoriesInMenu ? (
            <a
              tabIndex={setTabIndex(expanded)}
              onClick={() => setSelectedLink(category.EnglishTitle)}
              className={`btn navigationItem navigationParagraph`}
              href={category.Link}
            >
              {category.Name}
            </a>
          ) : (
            <>
              <button
                tabIndex={setTabIndex(expanded)}
                aria-expanded={selectedCategory == category && menuLevel === 4}
                aria-label={`${selectedCategory == category ? 'Close' : 'Open'} menu ${category.Name}`}
                aria-controls={`${id}-quaternaryLevel-${index}`}
                onClick={() => {
                  if (selectedCategory == category && menuLevel === 4) {
                    setMenuLevel(3);
                    setSelectedCategory(null);
                  } else {
                    setSelectedCategory(category);
                    setMenuLevel(4);
                  }
                }}
                className={`btn navigationItem navigationParagraph menuTertiaryLevel-item ${selectedCategory == category ? 'active' : ''}`}
              >
                {isMobile && menuLevel == 4 && <i aria-hidden="true" className="le-icon-chevron me-4"></i>}
                <span className="navigationParagraph">{category.Name}</span>
                {(!isMobile || menuLevel != 4) && <i className="le-icon-arrow rot-180" aria-hidden="true"></i>}
              </button>
              <NavigationQuaternaryLevel
                category={category}
                expanded={selectedCategory == category}
                isMobile={isMobile}
                controllid={`${id}-quaternaryLevel-${index}`}
              />
            </>
          )}
        </li>
      ))}
    </ul>
  );
};

const NavigationQuaternaryLevel = ({ category, expanded, controllid }) => {
  const { setSelectedLink, selectedCategory } = useAppState();
  return (
    <ul
      className={`menuQuaternaryLevel bg-color--0 navigationBottom ${expanded ? '' : 'siteHeader_hidden'}`}
      id={controllid}
    >
      <>
        <li className={`${selectedCategory == category ? '' : 'd-none'}`}>
          <a
            onClick={() => setSelectedLink(category.EnglishDiscoverAllText)}
            href={category.Link}
            className={`navigationItem navigationHeading`}
          >
            {category.DiscoverAllText}
            <i className="le-icon-arrow rot-180" aria-hidden="true"></i>
          </a>
        </li>
        {category?.SubCategories?.length > 0 &&
          category?.SubCategories.map((subCategory, i) => (
            <li key={i}>
              <a
                onClick={() => setSelectedLink(subCategory.EnglishTitle)}
                className={`navigationItem navigationParagraph ${selectedCategory == category ? '' : 'd-none'}`}
                href={subCategory.Link}
              >
                {subCategory.Name}
              </a>
            </li>
          ))}
      </>
    </ul>
  );
};
